import React from 'react'
import {
  BuyBox,
  ResumeWidget,
} from '../../../../common/components'
import FaqSchema from '../../../../common/components/FaqSchema'
import { Col, Row } from '../../../../common/lib'

const ArticleSidebar = ({
  article,
  location,
  faqs,
  sidebarLinksForInterviewAdvice,
}) => {
  return (
    <Col className="sidebar pb-4" md={4} lg={3}>
      {article.disableAds && (
        <Row>
          <Col>
            <div
              {...{
                className: 'mediavineAdsTop', // TODO: fixed class for Mediavine, don't change
                id: 'mediavineAdsTop', // TODO: fixed id for Mediavine, don't change
              }}
            />
          </Col>
        </Row>
      )}
      {/* <Row>
        <Col className="pt-5 pb-5">
          <div style={{ marginTop: '98px' }}>
            {location.pathname.match('interview-advice') && (
              <SidebarLinksForInterviewAdvice
                sidebarLinksForInterviewAdvice={sidebarLinksForInterviewAdvice}
              />
            )}
          </div>
        </Col>
      </Row> */}
      {article.disableAds && (
        <Row>
          <Col>
            <div
              {...{
                className: 'mediavineAdsBottom', // TODO: fixed class for Mediavine, don't change
                id: 'mediavineAdsBottom', // TODO: fixed id for Mediavine, don't change
              }}
            />
          </Col>
        </Row>
      )}
      <FaqSchema faqs={faqs} />

      {/* {!location.pathname.includes('/internships-graduate-schemes') && ( */}
      {location.pathname.includes('/application-advice/') ?
        <ResumeWidget slug={article.slug} ps={true} />
        : <BuyBox testUrl={article.heroButtonUrl} location={location} />
      }
    </Col>
  )
}

export default ArticleSidebar
